import { render, staticRenderFns } from "./devices.table.view.vue?vue&type=template&id=5c089e70&scoped=true&"
import script from "./devices.table.view.vue?vue&type=script&lang=js&"
export * from "./devices.table.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c089e70",
  null
  
)

export default component.exports